import React, { ChangeEvent, Fragment, useEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  Grid,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,

  Typography
} from '@mui/material';

import { withStyles } from '@mui/styles';
import { TableHeaderCell } from 'src/components/TableHeaderCell';
import {
  GetEmployeeProjectDetails,
} from 'src/services/projectService';
import { TableColumnCell } from 'src/components/TableColumnCell';
import { AppActions } from 'src/store/AppReducer';
import { useDispatch, } from 'react-redux';
import { useParams } from 'react-router-dom';
import moment from 'moment';


const applyPagination = (
  projects: any[],
  page: number,
  limit: number
): any[] => {
  return projects.slice(page * limit, page * limit + limit);
};

const EmployeeProjectDetails = () => {
  const dispatch = useDispatch();

  const [page, setPage] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);

  var initalList: any[] = [];
  const [projects, setProjects] = useState(initalList);

  const { employeeId } = useParams();



  const paginatedProjects = applyPagination(projects, page, limit);

  const handlePageChange = (event: any, newPage: number): void => {
    setPage(newPage);
  };

  const handleLimitChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setLimit(parseInt(event.target.value));
  };


  const GetEmployeeProjectDetailsbyID = (employeeId:any) => {
    dispatch(AppActions.showLoader());
    GetEmployeeProjectDetails(employeeId).then((res) => {
      const sortedData = res.data.sort((a, b) => {
        const dateA = new Date(a.startDate).getTime(); // Get timestamp for date A
        const dateB = new Date(b.startDate).getTime(); // Get timestamp for date B
        return dateB - dateA; // Compare timestamps (descending order)
      });
      setProjects(sortedData.filter(e => e.projectName.toLowerCase() !== 'bench'));
      dispatch(AppActions.hideLoader());
    });
  };


  useEffect(() => {
    GetEmployeeProjectDetailsbyID(employeeId);
  }, []);
;

  const CustomTableRow = withStyles({
    root: {
      background: '#E6E9FF !important',
      height: '3.5rem'
    }
  })(TableRow);

  return (
    <Fragment>
      <Grid container sx={{ mt: 2 }} justifyContent="space-between">
      </Grid>
      <Card>
        <TableContainer>
          <Table style={{ borderCollapse: 'separate' }} size="small">
            <TableHead>
              <CustomTableRow sx={{ py: 10 }}>
                <TableHeaderCell content="Allocation Start Date" smallFont />
                <TableHeaderCell content="Allocation End Date" smallFont />
                <TableHeaderCell content="Resource Type" smallFont />
                <TableHeaderCell content="Project Role" smallFont />
                <TableHeaderCell content="Allocation (%)" smallFont />
                <TableHeaderCell content="Customer" smallFont />
                <TableHeaderCell content="Project Name" smallFont />{' '}
              </CustomTableRow>
            </TableHead>
            <TableBody>
              {paginatedProjects &&
                paginatedProjects?.length > 0 &&
                paginatedProjects.map((listItem, i) => {
                  return (
                    <TableRow hover>
                      <TableColumnCell>
                        <Typography
                          paddingBottom="0.25rem"
                          paddingTop="0.5rem"
                          style={{ fontSize: '11px' }}
                          variant="body2"
                          gutterBottom
                          noWrap
                        >
                        {moment(listItem?.startDate?.split(` `)[0]).format(
                                    'YYYY/MM/DD'
                                  ) || '-'}
                        </Typography>
                      </TableColumnCell>
                      <TableColumnCell>
                        <Typography
                          paddingBottom="0.25rem"
                          paddingTop="0.5rem"
                          style={{ fontSize: '11px' }}
                          variant="body2"
                          gutterBottom
                          noWrap
                        >
                         {moment(listItem?.endDate?.split(` `)[0]).format(
                                    'YYYY/MM/DD'
                                  ) || '-'}
                        </Typography>
                      </TableColumnCell>
                      <TableColumnCell>
                        <Typography
                          paddingBottom="0.25rem"
                          paddingTop="0.5rem"
                          style={{ fontSize: '11px' }}
                          variant="body2"
                          gutterBottom
                          noWrap
                        >
                        {listItem?.type || '-'}
                        </Typography>
                      </TableColumnCell>
                      <TableColumnCell>
                        <Typography
                          paddingBottom="0.25rem"
                          paddingTop="0.5rem"
                          style={{ fontSize: '11px' }}
                          variant="body2"
                          gutterBottom
                          noWrap
                        >
                         {listItem?.role}
                        </Typography>
                      </TableColumnCell>
                      <TableColumnCell>
                        <Typography
                          paddingBottom="0.25rem"
                          paddingTop="0.5rem"
                          style={{ fontSize: '11px' }}
                          variant="body2"
                          gutterBottom
                          noWrap
                        >
                          {listItem?.allocation}
                        </Typography>
                      </TableColumnCell>
                      <TableColumnCell>
                        <Typography
                          paddingBottom="0.25rem"
                          paddingTop="0.5rem"
                          style={{ fontSize: '11px' }}
                          variant="body2"
                          gutterBottom
                          noWrap
                        >
                          {listItem?.customer || '-'}
                        </Typography>
                      </TableColumnCell>
                      <TableColumnCell>
                        <Typography
                          paddingBottom="0.25rem"
                          paddingTop="0.5rem"
                          style={{ fontSize: '11px' }}
                          variant="body2"
                          gutterBottom
                          noWrap
                        >
                          {listItem?.projectName}
                        </Typography>
                      </TableColumnCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        {paginatedProjects?.length === 0 && (
          <Typography
            style={{
              fontSize: '15px',
              fontWeight: 'bold',
              margin: '1rem',
              textAlign: 'center'
            }}
            variant="body2"
          >
            No Records Found
          </Typography>
        )}
        <Box p={2}>
          <TablePagination
            sx={{
              fontSize: '12px',
              '.MuiTablePagination-displayedRows': {
                fontSize: '12px'
              },
              '.MuiTablePagination-selectLabel': {
                fontSize: '12px'
              }
            }}
            component="div"
            count={projects?.length}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleLimitChange}
            page={page}
            rowsPerPage={limit}
            rowsPerPageOptions={[10, 20, 30, 40, 50]}
          />
        </Box>
      </Card>
    </Fragment>
  );
};

export default EmployeeProjectDetails;
